import { z } from 'zod'
import { zId, zIsoDate } from '../common'
import { zAdsAccountStatus } from '../enums'

// A connected Google Ads account. customerId is 10 digits (normalized
// server-side). currencyCode/timeZone arrive after the first sync.
export const zAdsAccount = z.object({
  id: zId,
  siteId: zId,
  customerId: z.union([z.string(), z.number()]).transform(String),
  descriptiveName: z.string().nullish().default(null),
  currencyCode: z.string().nullish().default(null),
  timeZone: z.string().nullish().default(null),
  status: zAdsAccountStatus,
  oauthEmail: z.string().nullish().default(null),
  loginCustomerId: z.union([z.string(), z.number()]).transform(String).nullish().default(null),
  lastSyncedAt: zIsoDate.nullish().default(null),
})
export type AdsAccount = z.infer<typeof zAdsAccount>

// POST /ads/accounts/connect → { authorizationUrl, state }. The SPA opens
// authorizationUrl in the browser; Google redirects to the server callback
// which hands back a ONE-SHOT oauth handle (15 min TTL).
export const zConnectResponse = z.object({
  authorizationUrl: z.string(),
  state: z.string(),
})
export type ConnectResponse = z.infer<typeof zConnectResponse>

// GET /ads/accounts/accessible_customers → the customer ids reachable with the
// handle. The handle is RE-ISSUED here and must be used for the final create
// (the previous one is consumed).
export const zAccessibleCustomers = z.object({
  customerIds: z.array(z.union([z.string(), z.number()]).transform(String)),
  oauthHandle: z.string(),
})
export type AccessibleCustomers = z.infer<typeof zAccessibleCustomers>
